export default __webpack_public_path__ + "static/media/pytorch.10ab8c68.svg";